export { default, type ErrorType } from './error-template';
